import React from 'react';
import PropTypes from 'prop-types';
import styles from './Auth.module.scss';

/**
 * Shared auth page shell with centered white card and legal line.
 */
const AuthShell = ({ children, className = '' }) => (
  <div className={`${styles.shell} ${className}`.trim()}>
    <div className={styles.wrap}>
      <div className={styles.card}>{children}</div>
      <p className={styles.legalLine}>
        &copy; Clowdy Ltd. t/a Twine.{' '}
        <a href="/terms" title="Terms Of Service">
          Terms
        </a>{' '}
        -{' '}
        <a href="/privacy" title="Privacy Policy">
          Privacy
        </a>
      </p>
    </div>
  </div>
);

AuthShell.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default AuthShell;
